import Vue from 'vue';
import {
  getDictionaryType, getUserTemplate, saveOrUpdateUserTemplate, getDecryptData,
  getDictionaryByPathCodeList,
} from '@/api/global';
import { getTabelColums } from '@/utils/table';
// import Queue from '@/utils/queue';

// const queue = new Queue();

const dictionary = {
  namespaced: true,
  state: {
    dictData: {},
    userTemplate: {},
  },
  mutations: {
    SET_DICTIONARY_ITEMS: (state, { data, dictionaryType }) => {
      if (!state.dictData[dictionaryType]) {
        Vue.set(state.dictData, dictionaryType, []);
      }
      state.dictData[dictionaryType] = data;
    },
    // 删除掉指定的字典
    DELETE_DICTIONARYTYPE(state, dictionaryType) {
      delete state.dictionaryItems[dictionaryType];
    },
    // 清除字典
    CLEAR_ALL_DICTIONARY(state, data = {}) {
      state.dictData = data;
    },
    SET_USER_TEMPLATE: (state, { data, key }) => {
      if (!state.userTemplate[key]) {
        Vue.set(state.userTemplate, key, []);
      }
      state.userTemplate[key] = data;
    },
  },
  actions: {
    // 字典查询
    async getDictionary({ commit, state }, { type, constraintRefresh = false }) {
      // queue.emit(async () => {
      if (!constraintRefresh && (state.dictData[type] && state.dictData[type]?.length > 0)) return;
      const { data } = await getDictionaryType({ constantType: type });
      commit('SET_DICTIONARY_ITEMS', { data, dictionaryType: type });
      // });
    },
    // 根据codePath查询字典
    async getDictionaryPath({ commit }, { paths = [] }) {
      try {
        const res = await getDictionaryByPathCodeList({
          codePaths: paths,
          projectType: 'front_end', // 工程类型, 前端传:front_end, 后端传:back_end
          project: 'finance-service-static', // 工程
        });
        const { data = [] } = res;
        if (data.length) {
          data.forEach((item) => {
            commit('SET_DICTIONARY_ITEMS', { data: item?.childs || [], dictionaryType: item.codePath });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 用户列表模板更新
    async setUserTemplate({ state }, params) {
      console.log(state);
      return new Promise(async (resolve, reject) => {
        try {
          await saveOrUpdateUserTemplate(params);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取用户列表模板
    async getUserTemplate({ state, commit }, { pageKeys, columnsKey, tableColumn, recommendedColumn = [] }) {
      return new Promise(async (resolve, reject) => {
        try {
          if (state.userTemplate[columnsKey] && state.userTemplate[columnsKey]?.length > 0) {
            const list = getTabelColums({ data: state.userTemplate[columnsKey], list: [...tableColumn, ...recommendedColumn] });
            resolve(list);
          } else {
            const res = await getUserTemplate({ pageKeys });
            const { data } = res;
            let values = tableColumn;
            let selectTableColumn = getTabelColums({ data: values, list: tableColumn });
            if (data.templates[columnsKey]) {
              values = JSON.parse(data.templates[columnsKey]);
              selectTableColumn = getTabelColums({ data: values, list: [...tableColumn, ...recommendedColumn] });
            }
            commit('SET_USER_TEMPLATE', { data: values, key: columnsKey });
            resolve(selectTableColumn);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    // 解密数据
    getDecryptData({ state }, { encryptData }) {
      console.log(state);
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getDecryptData({ encryptData });
          resolve(res.data);
        } catch (error) {
          this.currentBusiSource = [];
          reject(error);
        }
      });
    },
  },
};

export default dictionary;
